<div class="hp-recent-search-container">
  <div class="search-results">
    <ul>
      <li *ngFor="let savedTrip of savedTrips" class="airport-list">
        <a
          #selectedTrip
          (click)="selectedTripDetails(savedTrip)"
          draggable="false"
          href="javascript:void(0);"
          role="link"
        >
          {{ savedTrip.alias }}
        </a>
      </li>
    </ul>
  </div>
</div>
